import { slackDomain } from "@/screens/settings/integrations/slack-channel-list"

export interface BroadcastChannel {
	id: string
	name: string
	slackConnectSettingsId: string
}

export interface BroadcastChannelGroup {
	slackConnectSettingsId: string
	workspaceName: string
	channels: BroadcastChannel[]
}

/** The channels a changelog posts to, grouped by Slack workspace in connection order, names A-Z. */
export function groupBroadcastChannels(
	channels: readonly BroadcastChannel[],
	connections: readonly { id: string; teamUrl: string }[],
	query = "",
): BroadcastChannelGroup[] {
	const q = query.trim().toLowerCase()
	return connections
		.map((connection) => ({
			slackConnectSettingsId: connection.id,
			workspaceName: slackDomain(connection.teamUrl),
			channels: channels
				.filter(
					(channel) =>
						channel.slackConnectSettingsId === connection.id &&
						channel.name.toLowerCase().includes(q),
				)
				.sort((a, b) => a.name.localeCompare(b.name)),
		}))
		.filter((group) => group.channels.length > 0)
}
